import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
import $ from 'jquery';
import LazyLoad from 'vanilla-lazyload';

// Make GSAP and plugins globally available
if (!window.gsap) window.gsap = gsap;
if (!window.ScrollTrigger) window.ScrollTrigger = ScrollTrigger;
if (!window.ScrollToPlugin) window.ScrollToPlugin = ScrollToPlugin;
if (!window.$) window.$ = window.jQuery = $;
if (!window.LazyLoad) window.LazyLoad = LazyLoad;

// Register plugins
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

// Create a namespace for our engine
window.R24Engine = window.R24Engine || {};

// HELLO
const consolehead = [
  'color: white',
  'background: #ff5533',
  'font-size: 20px',
  'padding: 0.25em'
].join(';');
const consoletxt = [
    'color: white',
    'background: #ff5533',
    'font-size: 12px',
    'padding: 0.25em'
].join(';');

const message = 'MADE WITH ❤️ BY R24';
const message2 = 'For questions and feedback, contact: engine@relaunch24.de';

console.log('%c%s', consolehead, message);
console.log('%c%s', consoletxt, message2);

///////////////////////////////////////////////
// READY FOR STARTING THE ENGINE (VANILLA)
/////////////////////////////////////////////

async function init() {
  "use strict";

  // Performance tracking
  performance.mark('meta-engine-start');

  // Array to collect all imports
  const coreImports = [];

  ////////////////////////////////////////////////
  // IMPORT SCROLL
  ///////////////////////////////////////////////
  coreImports.push(import('./metacore/meta-scroll.js').then(module => {
    module.initMetaScroll();
  }));

  ////////////////////////////////////////////////
  // IMPORT DYNAMIC NAV OR SIDEBAR NAV
  ///////////////////////////////////////////////
  if (document.querySelector(".js-site-nav")) {  
    coreImports.push(import('./metacore/meta-nav-dynamic.js').then(module => {
      module.initDynamicNav();
    }));
  }

  if (document.querySelector(".meta-nav-sidebar")) {  
    coreImports.push(import('./metacore/meta-nav-sidebar.js').then(module => {
      module.initSidebarNav();
    }));
  }

  ////////////////////////////////////////////////
  // IMPORT COOKIES
  ///////////////////////////////////////////////
  if (document.querySelector("#footersettings")) {
    coreImports.push(import('./metacore/meta-cookies.js').then(module => {
      module.initMetaCookies();
    }));
  }

  ////////////////////////////////////////////////
  // IMPORT BLOCK MODULES
  ///////////////////////////////////////////////
  
  // Hero Video
  if (document.querySelector('#herovideo')) {
    coreImports.push(import('./metablocks/hero.js').then(module => {
      module.initHero();
    }));
  }

  // Forms
  if (document.querySelector('form')) {
    coreImports.push(import('./metablocks/misc_form.js').then(module => {
      module.initForm();
    }));
  }

  // Accordions
  if (document.querySelector('.faq6_accordion')) {
    coreImports.push(import('./metablocks/misc_accordion.js').then(module => {
      module.initAccordion();
    }));
  }

  // Numbers
  if (document.querySelector('.text-numbers')) {
    coreImports.push(import('./metablocks/misc_numbers.js').then(module => {
      module.initNumbers();
    }));
  }

  // Quantrefy Grid
  if (document.querySelector('.grid-card-quantrefy')) {
    coreImports.push(import('./metablocks/klients/quantrefy.js').then(module => {
      module.initQuantrefy();
    }));
  }

  // Wait for all core imports to complete
  await Promise.all(coreImports);

  //////////////////////////////////
  // PRELOADS
  /////////////////////////////////

  // @all preload-backup (FadeOut)
  setTimeout(function() {
    const transitions = document.querySelectorAll('.transition');
    transitions.forEach(function(transition) {
      // Using GSAP for fade-out effect
      gsap.to(transition, {
        opacity: 0,
        duration: 0.33,
        onComplete: function() {
          transition.remove();
        }
      });
    });
  }, 300);

    /////////////////////////////////////////////////
  // UI FIXES 
  /////////////////////////////////////////////////


  // @all immer der zweiten section die id 'start' geben
  const sections = document.querySelectorAll("section");
  if (sections.length > 0) {
    // Check if 'start' ID already exists
    const existingStart = document.getElementById('start');
    if (!existingStart) {
      const targetSection = sections.length > 1 ? sections[1] : sections[0];
      // Only set ID if the section doesn't already have one
      if (!targetSection.id) {
        targetSection.id = "start";
      }
    }
  }


  // Force Blank Tab on Textarea-Links
  // Check if the .content-richtext class is present
  if (document.querySelector('.content-richtext')) {
    // Get the current site's origin (protocol + domain)
    var currentOrigin = window.location.origin;
    
    // Apply the target attribute only for external links inside .content-richtext
    document.querySelectorAll('.content-richtext a').forEach(link => {
      const href = link.getAttribute('href');
      
      // Check if the link is external (i.e., its origin is different from the current one)
      // Also check if it's not a mailto: or tel: link
      if (href && !href.startsWith(currentOrigin) && (href.startsWith('http') || href.startsWith('//')) && !href.startsWith('mailto:') && !href.startsWith('tel:')) {
        link.setAttribute('target', '_blank');
      }
    });
    
    // Apply target="_blank" for all PDF links, regardless of whether they are internal or external
    // Also add the 'richlink' class to PDFs --R24 disabled for now
    document.querySelectorAll('.content-richtext a[href$=".pdf"]').forEach(link => {
      link.setAttribute('target', '_blank'); // Open in new tab
    });
  }



    


  //////////////////////////////////
  // VIDEO CONTROLLER (VANILLA)
  //////////////////////////////////

  // Get all video controller instances
  const vidcons = document.querySelectorAll('.vidcon');

  // Only run if video controllers are found
  if (vidcons.length > 0) {
    vidcons.forEach(vidcon => {
      const vidconbtn = vidcon.querySelector('.vidcon-btn');
      const mutebtn = vidcon.querySelector('.mute-btn');
      const player = vidcon.nextElementSibling; // Get the video element that follows the vidcon

      if (!vidconbtn || !player || player.tagName !== 'VIDEO') return; // Skip if required elements aren't found

      // Play/Pause functionality
      vidconbtn.addEventListener('click', () => {
        try {
          if (player.paused) {
            const playPromise = player.play();
            if (playPromise !== undefined) {
              playPromise.then(() => {
                vidconbtn.setAttribute('data-playing', 'true');
              }).catch(error => {
                console.log("Playback failed:", error);
              });
            }
          } else {
            player.pause();
            vidconbtn.setAttribute('data-playing', 'false');
          }
        } catch (e) {
          console.log("Video control error:", e);
        }
      });

      // Mute/Unmute functionality (only if mute button exists)
      if (mutebtn) {
        mutebtn.addEventListener('click', () => {
          try {
            if (player.muted) {
              player.muted = false;
              mutebtn.setAttribute('data-muted', 'false');
            } else {
              player.muted = true;
              mutebtn.setAttribute('data-muted', 'true');
            }
          } catch (e) {
            console.log("Mute control error:", e);
          }
        });
      }

      // Add hover animations for video controls
      [vidconbtn, mutebtn].filter(Boolean).forEach(btn => {
        btn.addEventListener('mouseenter', () => {
          gsap.to(btn, { y: -2.5, duration: 0.3, ease: 'power4.out' });
        });
        btn.addEventListener('mouseleave', () => {
          gsap.to(btn, { y: 0, duration: 0.3, ease: 'power4.out' });
        });
      });
    });
  }



    


  //////////////////////////////////////////////////
  // LIGHTBOX ENGINE
  //////////////////////////////////////////////////

  if (document.querySelector('.gallery-card a, figure a')) {
    $('.gallery-card a, figure a').simpleLightbox({ 
      /* options */ 
      navText: ['←','→'],
      captionDelay: 333,
      animationSlide: false,
    });
  }




  /////////////////////////////////////////////////
  // GLOBAL COUNT-UP ANIMATION (GSAP) FUNCTION!
  /////////////////////////////////////////////////

    // Function to animate counting
    function animateCount(element, targetValue, duration = 1) {
        const startValue = 0;
        const startTime = performance.now();
        
        function updateCount(currentTime) {
            const elapsedTime = currentTime - startTime;
            const progress = Math.min(elapsedTime / (duration * 1000), 1);
            
            // Ease out function for smoother animation
            const easeProgress = 1 - Math.pow(1 - progress, 3);
            
            const currentValue = Math.floor(startValue + (targetValue - startValue) * easeProgress);
            
            // Format number with thousands separator
            const formattedValue = currentValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            
            // Update the element's text content
            element.textContent = formattedValue;
            
            if (progress < 1) {
                requestAnimationFrame(updateCount);
            } else {
                // Ensure final value is exact
                element.textContent = targetValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            }
        }
        
        requestAnimationFrame(updateCount);
    }

    // Make function globally available
    window.animateCount = animateCount;

    // Check if there are any elements with data-animate-count
    if (document.querySelectorAll('[data-animate-count]').length > 0) {
        // Get all elements with data-animate-count
        const countElements = document.querySelectorAll('[data-animate-count]');
        
        // Reset initial state
        countElements.forEach(element => {
            element.textContent = '0';
        });

        // Create ScrollTrigger for the container
        ScrollTrigger.create({
            trigger: '[data-animate-count]',
            start: "top 80%",
            end: "bottom 20%",
            onEnter: () => {
                // Animate each element
                countElements.forEach(element => {
                    const targetValue = parseInt(element.getAttribute('data-animate-count'));
                    const duration = parseFloat(element.getAttribute('data-animate-duration')) || 1;
                    
                    if (!isNaN(targetValue)) {
                        animateCount(element, targetValue, duration);
                    }
                });
            },
            onLeaveBack: () => {
                // Reset state when scrolling back out
                countElements.forEach(element => {
                    element.textContent = '0';
                });
            }
        });
    }




  //////////////////////////////////////////////////
  // GLOBAL SUPER HERO TEXT ANIMATION (JQUERY)
  ////////////////////////////////////////////////////

  class SuperheroAnimation {
    constructor(element) {
      this.element = element;
      this.words = element.getElementsByClassName('word');
      this.wordArray = [];
      this.currentWord = 0;
      this.wordChangeInterval = null;
      this.isVisible = false;

      if (this.words.length > 0) {
        this.init();
      }
    }

    init() {
      this.words[this.currentWord].style.opacity = 1;

      for (let i = 0; i < this.words.length; i++) {
        this.splitLetters(this.words[i]);
      }

      this.setupScrollTrigger();
    }

    changeWord() {
      if (!this.isVisible) return;

      const cw = this.wordArray[this.currentWord];
      const nextIndex = (this.currentWord === this.words.length - 1) ? 0 : this.currentWord + 1;
      const nw = this.wordArray[nextIndex];

      for (let i = 0; i < cw.length; i++) {
        this.animateLetterOut(cw, i);
      }

      for (let i = 0; i < nw.length; i++) {
        nw[i].className = 'letter behind';
        if (nw[0]?.parentElement) {
          nw[0].parentElement.style.opacity = 1;
        }
        this.animateLetterIn(nw, i);
      }

      this.currentWord = nextIndex;
    }

    animateLetterOut(cw, i) {
      setTimeout(() => {
        cw[i].className = 'letter out';
      }, i * 80);
    }

    animateLetterIn(nw, i) {
      setTimeout(() => {
        nw[i].className = 'letter in';
      }, 340 + (i * 80));
    }

    splitLetters(word) {
      const content = word.textContent;
      word.innerHTML = '';
      const letters = [];

      for (let i = 0; i < content.length; i++) {
        const letter = document.createElement('span');
        letter.className = 'letter';
        letter.innerHTML = content.charAt(i);
        word.appendChild(letter);
        letters.push(letter);
      }

      this.wordArray.push(letters);
    }

    setupScrollTrigger() {
      ScrollTrigger.create({
        trigger: this.element,
        start: "top 80%",
        end: "bottom 20%",
        onEnter: () => {
          this.isVisible = true;
          if (!this.wordChangeInterval) {
            this.changeWord();
            this.wordChangeInterval = setInterval(() => this.changeWord(), 3000);
          }
        },
        onLeave: () => {
          this.isVisible = false;
          clearInterval(this.wordChangeInterval);
          this.wordChangeInterval = null;
        },
        onEnterBack: () => {
          this.isVisible = true;
          if (!this.wordChangeInterval) {
            this.changeWord();
            this.wordChangeInterval = setInterval(() => this.changeWord(), 3000);
          }
        },
        onLeaveBack: () => {
          this.isVisible = false;
          clearInterval(this.wordChangeInterval);
          this.wordChangeInterval = null;
        }
      });
    }

    destroy() {
      clearInterval(this.wordChangeInterval);
      this.wordChangeInterval = null;
    }
  }

  // Initialize all superhero elements
  const superheroElements = document.querySelectorAll('[data-superhero]');
  const superheroInstances = [];

  superheroElements.forEach(element => {
    superheroInstances.push(new SuperheroAnimation(element));
  });

  // Cleanup on page unload
  window.addEventListener('beforeunload', () => {
    superheroInstances.forEach(instance => instance.destroy());
  });



      






  //
  //
  //
  //
  //
  // PERFORMANCE CHECK END
  //
  //
  //
  //
  //
  //
  //

  // Mark performance end
  performance.mark('meta-engine-end');
  performance.measure('meta-engine-duration', 'meta-engine-start', 'meta-engine-end');
  const duration = performance.getEntriesByName('meta-engine-duration')[0].duration;
  console.log('%c%s', consoletxt, `R24 Engine init in ${duration.toFixed(2)}ms`);
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
